import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-companies-edit',
  templateUrl: './companies-edit.component.html',
  styleUrls: ['./companies-edit.component.scss']
})
export class CompaniesEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
